/** ***
------------------------------------------------------------------------

------------------------------------------------------------------------


** ***/
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const quarantinedFilesMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'objectpath',
        description: 'Progression Link',
        display: 'link',
        linkLabel: {
          labelName: 'linkLabel'
        },
        label: 'Progression',
        'min-width': 150,
        pathTo: 'attack-track-details',
        params: {
          name: 'trailId',
          keyLookup: 'parentTrailHash'
        },
        sortable: true,
        name: 'parentTrailHash'
      },
      {
        datatype: 'string',
        label: 'Hostname',
        description: 'Hostname',
        sortable: true,
        name: 'hostname',
        'min-width': 150
      },
      {
        datatype: 'string',
        label: 'Filename',
        description: 'Filename',
        sortable: true,
        'min-width': 200,
        name: 'file'
      },
      {
        datatype: 'string',
        label: 'OS',
        description: 'OS',
        sortable: true,
        name: 'os',
        'min-width': 100
      },
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT,
        description: 'Created Time',
        label: 'Created Time',
        name: 'timestamp',
        sortable: true,
        'min-width': 180
      },
      {
        datatype: 'string',
        label: 'Status',
        description: 'Status',
        sortable: true,
        display: 'colorTag',
        name: 'status',
        'min-width': 150,
        displayKey: [
          {
            key: 'quarantined',
            display: 'Quarantined',
            color: '#e1f3d8',
            textColor: '#60c030'
          },
          {
            key: 'restored',
            display: 'Restored',
            color: '#f4f4f4',
            textColor: '#666666'
          }
        ]
      }
    ]
  }
}

export { quarantinedFilesMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/response_actions/quarantined-files-meta.js